import { ColumnConfig, JobsScreenColumnKey } from '../../model';

export const jobsScreenConfig: Record<JobsScreenColumnKey, ColumnConfig> = {
  scheduleReport: {
    name: 'Schedule Report',
  },
  reportDateRange: {
    name: 'Report Date Range',
  },
  filters: {
    name: 'Filters',
    isComponent: true,
    field: 'component',
  },
  triggerOn: {
    name: 'Trigger On',
  },
  actions: {
    name: 'Actions',
    isComponent: true,
    alignment: 'flex-end',
    field: 'component',
  },
};
